import { useCallback, useEffect, useRef, useState } from 'react';
import {
    DEFAULT_SOUND, SOUND_ACTIONS, COOLDOWN_MS, GAP_MS,
    loadSettings, saveSettings, diffDecisions, playTone, audioState, installUnlock,
} from './decisionSound';

/** Tarama satırlarını izler; bir coinin kararı yeni AÇ (veya açıksa EMİR KOY) olunca ton çalar ve onEvent'i çağırır. */
export default function useDecisionSound(rows, onEvent) {
    const [settings, setSettings] = useState(loadSettings);
    const [audio, setAudio] = useState(audioState);
    const [lastEvent, setLastEvent] = useState(null);
    const prev = useRef(new Map());
    const cooldown = useRef(new Map());
    const nextSlot = useRef(0);
    const settingsRef = useRef(settings);
    settingsRef.current = settings;
    const onEventRef = useRef(onEvent);
    onEventRef.current = onEvent;

    useEffect(() => installUnlock((s) => setAudio(s)), []);

    const update = useCallback((patch) => {
        setSettings((s) => {
            const n = { ...DEFAULT_SOUND, ...s, ...patch };
            saveSettings(n);
            return n;
        });
    }, []);

    const test = useCallback((action) => {
        const ok = playTone(action, settingsRef.current.volume);
        setAudio(audioState());
        return ok;
    }, []);

    useEffect(() => {
        if (!rows || rows.length === 0) return;
        const { next, events } = diffDecisions(prev.current, rows);
        prev.current = next;
        const s = settingsRef.current;
        const now = Date.now();
        for (const ev of events) {
            if (!s.enabled || !s[SOUND_ACTIONS[ev.action]]) continue;
            const key = `${ev.symbol}|${ev.action}`;
            if ((cooldown.current.get(key) || 0) > now - COOLDOWN_MS) continue;
            cooldown.current.set(key, now);
            const delay = Math.max(0, nextSlot.current - now);
            nextSlot.current = now + delay + GAP_MS;
            setTimeout(() => {
                const played = playTone(ev.action, settingsRef.current.volume);
                setAudio(audioState());
                setLastEvent({ ...ev, at: Date.now(), played });
                onEventRef.current?.(ev, played);
            }, delay);
        }
    }, [rows]);

    return { settings, update, test, audio, lastEvent };
}
